import type { IconType } from '../../../../theme/themes/ThemeTypes';

export const Finance: IconType = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={43} height={42} fill="none" {...props}>
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1.94 20.994c0 11.043 8.952 19.994 19.995 20.006 11.043 0 19.994-8.95 20.006-19.994C41.929 9.951 32.978 1 21.935 1 10.892 1 1.94 9.95 1.94 20.994ZM14.98 20.994h8.697"
    />
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M26.277 15.78a3.484 3.484 0 0 0-6.967 0v7.827c0 2.878-.593 6.084-3.483 6.084h10.426"
    />
  </svg>
);
